module.exports = "/static-assets/_next/static/images/save-8eb740fe746fb0303832970aded2b5b1.png";